module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-regular-pro-d5a65842ed40722b0158f3ac31d0fcce.woff";